export const APP_VERSION = "342";
